import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-jorge-basadre',
  templateUrl: './jorge-basadre.component.html',
  styleUrls: ['./jorge-basadre.component.scss']
})
export class JorgeBasadreComponent implements OnInit {

  constructor(private titleService: Title) {
    this.titleService.setTitle("JORGE BASADRE");
  }

  ngOnInit(): void {
  }

  slides = [
    { id: "http://hdl.handle.net/20.500.14428/79297", img: "/assets/images/micrositio/micrositio23/BASADRE-018.jpg", autor: "", anno: "15 enero de 1945", anuNacimiento: "Carta dirigida a Walter Justus" },
    { id: "http://hdl.handle.net/20.500.14428/79296", img: "/assets/images/micrositio/micrositio23/BASADRE-019.jpg", autor: "", anno: "19 enero de 1945", anuNacimiento: "Carta de Godofredo García a Jorge Basadre" },
    { id: "http://hdl.handle.net/20.500.14428/79298", img: "/assets/images/micrositio/micrositio23/BASADRE-020.jpg", autor: "", anno: "28 enero de 1945", anuNacimiento: "Carta de Jorge Basadre a Francisco Tudela" },
    { id: "http://hdl.handle.net/20.500.14428/79299", img: "/assets/images/micrositio/micrositio23/BASADRE-021.jpg", autor: "", anno: "29 enero de 1945", anuNacimiento: "Carta a Fortunato Herrera" },

    { id: "http://hdl.handle.net/20.500.14428/79301", img: "/assets/images/micrositio/micrositio23/BASADRE-022.jpg", autor: "", anno: "30 de enero de 1945", anuNacimiento: "Cartas de Jorge Basadre a José Antonio de Lavalle" },
    { id: "http://hdl.handle.net/20.500.14428/79300", img: "/assets/images/micrositio/micrositio23/BASADRE-023.jpg", autor: "", anno: "", anuNacimiento: "[Carta de] Jorge Basadre, 1945 enero 30, Lima [para] José Antonio Lavalle" },
    { id: "http://hdl.handle.net/20.500.14428/79302", img: "/assets/images/micrositio/micrositio23/BASADRE-024.jpg", autor: "", anno: "11 enero de 1945", anuNacimiento: "Carta de Jorge Basadre al Gerente de la Compañía Nacional de Teléfono" },
    { id: "http://hdl.handle.net/20.500.14428/79306", img: "/assets/images/micrositio/micrositio23/BASADRE-025.jpg", autor: "", anno: "25 febrero de 1945", anuNacimiento: "Carta de Alejandro Miró Quesada a Jorge Basadre" },

    { id: "http://hdl.handle.net/20.500.14428/79307", img: "/assets/images/micrositio/micrositio23/BASADRE-026.jpg", autor: "", anno: "14 setiembre de 1944", anuNacimiento: "Carta de Luis Alberto Sánchez a Jorge Basadre" },
    { id: "http://hdl.handle.net/20.500.14428/79308", img: "/assets/images/micrositio/micrositio23/BASADRE-027.jpg", autor: "", anno: "16 octubre de 1944", anuNacimiento: "Carta de Juan Mejía Baca a Jorge Basadre" },
    { id: "http://hdl.handle.net/20.500.14428/79303", img: "/assets/images/micrositio/micrositio23/BASADRE-028.jpg", autor: "", anno: "23 noviembre de 1944", anuNacimiento: "Carta dirigida a Guillermo Lohmann 1/2" },
    { id: "http://hdl.handle.net/20.500.14428/79303", img: "/assets/images/micrositio/micrositio23/BASADRE-029.jpg", autor: "", anno: "23 noviembre de 1944", anuNacimiento: "Carta dirigida a Guillermo Lohmann 2/2" },
    { id: "http://hdl.handle.net/20.500.14428/79304", img: "/assets/images/micrositio/micrositio23/BASADRE-030.jpg", autor: "", anno: "11 diciembre de 1944", anuNacimiento: "Carta dirigida a José G. Cosio" }
  ];

  slideConfig = {
    "slidesToShow": 5, "slidesToScroll": 1, "responsive": [
      {
        'breakpoint': 850,
        'settings': {
          'slidesToShow': 1
        }
      }
    ]
  };

}
